<template>
    <div class="card">
        <slot name="header" />
        <slot />
        <slot name="footer" />
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss">
.card {
    background-color: #fff;
    margin-top: 48px;
    margin-bottom: 24px;
    position: relative;
    padding-bottom: 10px;
    @extend %default-borderRadius;
    @extend %default-shadow;

    header {
        top: -24px;
        margin: 0 auto;
        max-width: calc(100% - 32px);
        position: relative;
        background-color: $accent-color;
        box-sizing: border-box;
        padding: 0 20px;
        display: block;
        height: auto;
        @extend %default-borderRadius;
        @extend %default-shadow;

        div {
            display: block;
            width: 100%;
        }

        .title {
            font-size: 18px;
            padding: 15px 0 0;
        }

        .description {
            font-size: 14px;
            padding: 5px 0 15px;
        }
    }

    main {
        box-sizing: border-box;
        padding: 10px 20px 30px 20px;

        h2 {
            font-size: 18px;
            font-weight: 400;
            line-height: 1;
            letter-spacing: .02em;
            padding: 0 0 10px 10px;
            border-bottom: solid 1px rgba(0,0,0,.06);
        }

        hr {
            height: 1px;
            background-color: rgba(0,0,0,.2);
            border: none;
            margin: 30px 0;
        }
    }

    footer {
        box-sizing: border-box;
        margin: 30px 20px 0 20px;
        padding: 10px 0 10px 0;
        text-align: right;
        border-top: 1px solid rgba(0,0,0,.06);

        .fluke-btn {
            margin-left: 20px;
        }
    }
}
</style>


